<template>
  <div>
    <SceneFull :index="index" :scene="scene" :type="scene.type" :flag="scene.flag" v-if="!editable">
      <template v-slot:image>
        <img :src="scene.imageSmall" />
      </template>
      <template v-slot:imageFull>
        <img :src="scene.imageBig" />
      </template>
    </SceneFull>
    <SceneFullPreview :index="index" :scene="scene" :type="scene.type" :flag="scene.flag" :sceneId="sceneId" v-if="editable" :previewList="previewList">
      <template v-slot:image>
        <img :src="scene.imageSmall" />
      </template>
      <template v-slot:imageFull>
        <img :src="scene.imageBig" />
      </template>
    </SceneFullPreview>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SceneFull from "@/components/Infographics/SceneFull";
import SceneFullPreview from "@/views/Editor/SceneFull";

export default {
  name: "scene",

  props: {
    scene: Object,
    type: String,
    flag: String,
    index: Number,
    editable: Boolean,
    sceneId: String,
    previewList: Boolean,
  },

  components: {
    SceneFull,
    SceneFullPreview
  }
};
</script>